import axios from "axios";
import store from "../store";
import { resolveLanguage } from "../i18n/language";

// Базовый клиент для API без явного указания Content-Type по умолчанию
const apiClient = axios.create({
  baseURL: "/api",
});

// Интерсептор для добавления токена в заголовки и корректировки Content-Type, если отправляется FormData
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    config.headers.hostname = window.location.hostname;

    const state = store.getState();
    config.headers.provider = encodeURIComponent(
      state?.app?.provider ?? "default",
    );

    const language = resolveLanguage({
      provider: state?.app?.provider,
      roles: state?.user?.roles,
      preferredLanguage: localStorage.getItem("language"),
    });
    config.headers["X-Language"] = language;

    // Если данные являются FormData, удаляем заголовок Content-Type,
    // чтобы axios установил его корректно
    if (config.data instanceof FormData) {
      delete config.headers["Content-Type"];
    }
    return config;
  },
  (error) => Promise.reject(error),
);

// Интерсептор для обработки ошибок
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response, config } = error;
    if (response && response.status === 401) {
      // Если запрос не к эндпоинту /auth — редирект на главную
      if (!config.url.includes("/auth")) {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        window.location.href = "/";
      }
    }
    return Promise.reject(error);
  },
);

export default apiClient;
